import type React from 'react';

import type { IconProps } from './BaseIcon';
import { BaseIcon } from './BaseIcon';

export const ArrowRightIcon: React.FC<IconProps> = ({ ...props }) => (
  <BaseIcon {...props}>
    <path d="M27.707 15.293a1 1 0 0 1 0 1.414l-8.5 8.5a1 1 0 0 1-1.414-1.414L24.586 17H5a1 1 0 1 1 0-2h19.586l-6.793-6.793a1 1 0 0 1 1.414-1.414l8.5 8.5Z" />
  </BaseIcon>
);
